import { render, staticRenderFns } from "./ReturnDialog.vue?vue&type=template&id=a45f9f58&scoped=true&"
import script from "./ReturnDialog.vue?vue&type=script&lang=js&"
export * from "./ReturnDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a45f9f58",
  null
  
)

export default component.exports